export const BLOCKED_MICROSOFT = [
    'oulook.dk',
    'oulook.com',
    'outlokk.fr',
    'outlouk.fr',
    'oullook.com',
    'outlouk.com',
    'outloo.com',
    'liive.no',
    'hotmai.com',
    'hotamil.com',
    'hormail.com',
    'hormail.no',
    'homail.no',
    'homail.com',
    'hotmsil.com',
    'hootmail.com',
    'homtail.com',
    'hotmai.coml',
    'hotmial.com',
    'hltmail.fr',
    'homtail.fr',
    'hotail.fr',
    'hotlail.fr',
    'homail.fr',
    'hotnail.com',
    'hotmail.con',
    'hotmail.ccom',
    'hormail.dk',
    'hotmail.como',
    'hotnail.dk',
    'hotmal.no',
    'live.con',
    'livr.dk',
    'livse.se',
    'outlook.con',
    'otmail.com',
    'live.cim',
    'livr.se',
    'hoail.com',
    'outkook.fr',
    'autlook.dk',
    'hoail.com',
    'hotmail.xom',
    'hotmil.com',
    'hotmaio.com',
    'outlok.com',
    'hormail.se',
    'utlook.com',
    'hotmai.co.uk',
    'hotrmail.com',
    'homail.dk',
    'hotmaill.com',
    'hotnail.co.uk',
    'outlook.vom',
    'hitmail.com',
    'hotmail.co',
    'uotlook.com',
    'ourlook.com',
    'hotemail.com',
    'hotmail.cim',
    'hotmail.vom',
    'hotmaul.com',
    'hotmail.tr',
    'hitmail.dk',
    'live.ss',
    'hitmail.se',
    'oultook.fr',
    'oultook.com',
];
const BLOCKED_GMAIL = [
    'gamil.com',
    'gamail.com',
    'gamil.con',
    'gamil..com',
    'gimal.com',
    'gamil.vom',
    'gmail.om',
    'gmqil.com',
    'gmaiø.com',
    'g.mail.com',
    'gemail.com',
    'gmail.co',
    'gmali.com',
    'gmal.com',
    'gmail.org',
    'gmaik.com',
    'gmai.com',
    'gmial.com',
    'glail.com',
    'gmail.con',
    'gnail.com',
    'gmile.com',
    'gmil.com',
    'gmail.cim',
    'gmsil.com',
    'gmailc.om',
    'gmail.stockholm.se',
    'gmail.com.com',
    'gmai.l.com',
    'gmai.l.com',
    'gail.com',
    'gmail.como',
    'googlemailc.om',
    'gmaild.com',
    'fmail.com',
    'hmail.com',
    'gmqil.com',
    'gmaio.com',
    'gmaul.com',
    'gmaip.com',
    'gmalil.com',
    'gmail.comm',
    'gail.com',
    'gmail.cm',
    'gmail.clm',
    'gmaill.com',
    'gnail.con',
    '66gmail.com',
    'geemail.com',
];
export const BLOCKED_OTHER = [
    'icould.com',
    'iclud.com',
    'cloud.com',
    'ilcloud.com',
    'icluod.com',
    'icoud.com',
    'icooud.com',
    'icloude.com',
    'icloud.con',
    'yahho.com',
    'yahho.fr',
    'yahho.no',
    'yhoo.dk',
    'yahoo.con',
    'yahoogmail.com',
    'uahoo.com',
    'uahoo.fr',
    'uahoo.se',
    'uahoo.dk',
    'onlin.no',
    'jubii.djk',
    'essoskei.no',
    'omline.no',
    'stavamgerskolen.no',
    'online.ni',
    'iclod.com',
    'icloed.con',
    'icloud.cim',
    'icloed.com',
    'iclour.com',
    'yaho.com',
    'me.con',
    'icloud.vom',
    'ymail.cim',
    'yaoot.fr',
    'wannadoo.fr',
    'stavamgerskolen.no',
    'mail.ck',
    'online.mo',
    'yahho.se',
    'ayet.sk',
    'seynam.cz',
    'seynam.cy',
    'alo.com',
    'aol.co',
    'aol.cm',
];
export const BLOCKED = [...BLOCKED_GMAIL, ...BLOCKED_MICROSOFT, ...BLOCKED_OTHER];
